import React, { FC } from 'react';
import cls from 'classnames';
import { ToolbarProps } from './Toolbar.types';
import { getClassNames, getRootClassListFromProps } from '../../../utilities/classNames';
import ButtonIcon from '../../button/buttonIcon';

import ButtonStandard from '../../button/buttonStandard';

export const classNames = getClassNames('sds-toolbar', [
	'variant-page',
	'variant-section',
	'left-action',
	'right-action',
	'text-content',
]);


const Toolbar: FC<ToolbarProps> = (props) => {
	const {variant, header } = props
	const HeaderTag =  props.tag || 'div';
	return (
	<div className={cls(getRootClassListFromProps(classNames, props))}>
		{(() => {
			if (variant.type === 'page') {
				const { navButtonIcon, firstButtonIcon, secondButtonIcon  } = variant;

				return (
					<>
						<div className={classNames.leftAction}>
							<ButtonIcon {...navButtonIcon} />
						</div>
						<HeaderTag className={classNames.textContent}>
							{header}
						</HeaderTag>
						<div className={classNames.rightAction}>
							{firstButtonIcon && <ButtonIcon {...firstButtonIcon} />}
							{secondButtonIcon && <ButtonIcon {...secondButtonIcon} />}
						</div>
					</>
				);
			}
			
			if (variant.type === 'section') {
				const { button, firstButtonIcon, secondButtonIcon  } = variant;
				return (
					<>
						<HeaderTag className={classNames.textContent}>
							{header}
						</HeaderTag>
						<div className={classNames.rightAction}>
							<ButtonStandard size="medium" variant='secondary' onClick={button.onClick} leftIcon={button.Icon}>
									{button.text}
							</ButtonStandard >
							{firstButtonIcon && <ButtonIcon variant='secondary' {...firstButtonIcon} />}
							{secondButtonIcon && <ButtonIcon variant='secondary' {...secondButtonIcon} />}
						</div>
					</>
				);
			}
		})()}
	</div>);
};

Toolbar.displayName = 'Toolbar';

export default Toolbar;
